module.exports = __webpack_public_path__ + "static/media/networking.e9b5d602.png";